import React from "react";
import { photoRatio, photoSources } from "../../utils/photos";

/**
 * Foto propia o marcador.
 *
 * Nunca pinta Unsplash. Si el manifiesto no tiene archivo, reserva el espacio
 * con el ratio correcto para no mover el layout cuando lleguen las fotos.
 *
 * `bn` es el tratamiento del sitio público: la foto va en blanco y negro y
 * recupera el color al pasar el cursor. Reacciona también al `group` de un
 * ancestro, porque en las tarjetas y en el hero hay capas encima de la imagen
 * y el cursor nunca llega a tocarla. Las entregas a clientes no lo usan: ahí
 * las fotos son del cliente y se ven como se le entregaron.
 */
const BN = "grayscale transition duration-500 hover:grayscale-0 group-hover:grayscale-0";

const PhotoImage = ({
  foto,
  image,
  ratio,
  sizes,
  className = "",
  priority = false,
  bn = false,
  alt,
}) => {
  const source = foto || image;
  const sources = photoSources(source, sizes ? { sizes } : undefined);
  const aspect = photoRatio(source, ratio || 0.75);

  if (!sources) {
    return (
      <div
        className={`bg-navy-800 ${className}`}
        style={{ aspectRatio: `${1 / aspect}` }}
        role="img"
        aria-label={alt || source?.alt || "Fotografía pendiente de publicar"}
      />
    );
  }

  return (
    <img
      src={sources.src}
      srcSet={sources.srcSet}
      sizes={sources.sizes}
      width={sources.width}
      height={sources.height}
      alt={alt || source.alt || ""}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchpriority={priority ? "high" : undefined}
      className={bn ? `${BN} ${className}` : className}
    />
  );
};

export default PhotoImage;
